import styled from 'styled-components';

export const JobListingDetailFormStyles = styled.div`
  .ant-form-item-label > label {
    color: ${({ theme }) => theme.text.blackNeutral800} !important;
  }
`;
